import React, { useState } from "react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { svg } from "../../../../../Assets/svg";
import { useAppDispatch } from "../../../../../store";
import { updateOrderAccountsApprovalAPI } from "../../orderApis";
import { syncSageDataAPI } from "../../../../Redux/sage";

interface AccountsApprovalModalProps {
  visible: boolean;
  onClose: () => void;
  orderData?: any;
  onSuccess?: (updatedData?: any) => void;
}

const AccountsApprovalModal: React.FC<AccountsApprovalModalProps> = ({
  visible,
  onClose,
  orderData,
  onSuccess,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const orderId = orderData?.order_id || "-";
  const companyName =
    orderData?.customer_snapshot?.company_name ||
    orderData?.customer_snapshot?.first_name ||
    "-";

  const handleUpdateCustomerDetails = () => {
    const customerId =
      orderData?.customer_id?._id ||
      orderData?.customer_id ||
      orderData?.customer_snapshot?.customer_id ||
      orderData?.customer_snapshot?._id;
    if (customerId && orderData?._id) {
      navigate(
        `/clients-distributors/${customerId}?order_id=${orderData._id}`
      );
      onClose();
    }
  };

  const handleApprove = () => {
    if (!orderData?._id) return;
    setLoading(true);
    dispatch(
      updateOrderAccountsApprovalAPI({
        order_id: orderData._id,
        onSuccess: (data) => {
          setLoading(false);
          onSuccess?.(data);
          onClose();
          dispatch(syncSageDataAPI({ hideToast: true }) as any);
        },
        onError: () => {
          setLoading(false);
        },
      })
    );
  };

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Accounts Approval Needed
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"50rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center align-items-center flex-nowrap gap-2 gap-sm-3">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary px-3 text-nowrap"
            onClick={onClose}
            disabled={loading}
          >
            CLOSE
          </button>
          <button
            type="button"
            className="btn btn-lg btn-outline-primary px-3 fw-semibold text-nowrap"
            onClick={handleUpdateCustomerDetails}
            disabled={loading}
          >
            UPDATE CUSTOMER DETAILS
          </button>
          <button
            type="button"
            className="btn btn-lg btn-primary px-3 d-inline-flex align-items-center justify-content-center text-nowrap"
            onClick={handleApprove}
            disabled={loading}
          >
            {loading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            MARK ACCOUNTS APPROVED
          </button>
        </div>
      }
    >
      <div className="py-2">
        <div className="text-center mb-4">
          <div className="fs-5 fw-bold text-dark mt-2">Order #{orderId}</div>
          {companyName !== "-" && (
            <div className="text-secondary fs-6">{companyName}</div>
          )}
        </div>

        <div className="mb-4">
          <p className="mb-3 text-secondary text-center fs-6">
            This order is currently pending verification and approval by the
            Accounts team. Sage synchronization is on hold until approved.
          </p>
          <div
            className="alert alert-info py-2 px-3 mb-0 d-flex justify-content-center"
            role="alert"
            style={{ fontSize: "13px" }}
          >
            <span className="me-2 fw-bold">Note:</span>
            <span>
              Once this order is approved, the Sage sync process will begin. This may take a few minutes. Please check the order's Sage sync status after some time.
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AccountsApprovalModal;
